// Environment variables with defaults
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3002/api/v1';
export const API_KEY = import.meta.env.VITE_API_KEY || '';
export const FRONTEND_URL = import.meta.env.VITE_FRONTEND_URL || 'http://localhost:5173';
export const REDIRECT_URI = import.meta.env.VITE_REDIRECT_URI || 'http://localhost:3002/api/v1/auth/callback';

// Auth0 Configuration
export const AUTH0_DOMAIN = import.meta.env.VITE_AUTH0_DOMAIN;
export const AUTH0_CLIENT_ID = import.meta.env.VITE_AUTH0_CLIENT_ID;
export const AUTH0_ORGANIZATION_ID = import.meta.env.VITE_AUTH0_ORGANIZATION_ID;

// Environment indicator
export const IS_PRODUCTION = import.meta.env.PROD || false;
export const ENV_MODE = import.meta.env.MODE || 'development'; 